var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report'),_c('saveKTV'),_c('v-toolbar',{staticClass:"secondary",attrs:{"dark":""}},[_c('v-toolbar-title',{staticClass:"ml-15"},[_vm._v(_vm._s(_vm.name))]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }